import { css as CSS } from 'styled-components'
import { mobile } from './media'

export type TextProps = {
  css?: any
  isBold?: boolean
  mb?: [number, number] | number
  pb?: number
}

export function common({ css, isBold, mb, pb }: TextProps) {
  return CSS`
    ${isBold ? 'font-weight: bold;' : ''}
    ${
      mb
        ? Array.isArray(mb)
          ? `
      margin-bottom: ${mb[0]}px;
      @media ${mobile} {
        margin-bottom: ${mb[1]}px;
      }
    `
          : `margin-bottom: ${mb}px;`
        : ''
    }
    ${pb ? `padding-bottom: ${pb}px;` : ''}
    ${css ? css : ''}
  `
}
